module.exports = __webpack_public_path__ + "static/media/KHELOCARD.dd38889a.svg";